/**
 * Simonara public analytics beacon — minimal fire-and-forget wrapper around
 * navigator.sendBeacon (falls back to fetch keepalive on Safari <15 / older
 * browsers). ONLY the events + property keys whitelisted server-side in
 * routers/public.py::ALLOWED_TRACK_EVENTS make it into the events collection —
 * anything else is silently dropped. Never send PII.
 */
const BASE = process.env.REACT_APP_BACKEND_URL;

export const trackEvent = (event, properties = {}) => {
    try {
        const url = `${BASE}/api/track`;
        const payload = JSON.stringify({ event, properties });
        if (typeof navigator !== "undefined" && typeof navigator.sendBeacon === "function") {
            const blob = new Blob([payload], { type: "application/json" });
            navigator.sendBeacon(url, blob);
            return;
        }
        // Fallback for browsers without sendBeacon — keepalive so the request
        // survives even if the tab navigates away immediately after the call.
        fetch(url, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: payload,
            keepalive: true,
        }).catch(() => {});
    } catch {
        /* never let analytics crash the page */
    }
};
